module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locked",
    class: {
      locked_inlay: _vm.inlay, locked_up: _vm.isCost
    }
  }, [_vm._v("Запись приостановлена")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a33501","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/item/components/Locked.vue
// module id = db570eacdf7bd7e4a7fb
// module chunks = 89